import { Controller } from '@hotwired/stimulus'
import { post } from '../../lib/request'

export default class extends Controller {
  static targets = [
    'orderNumber',
  ]

  static values = {
    path: String,
    orderPath: String,
    cancelOrderPath: String,
  }

  go = () => {
    const value = this.orderNumberTarget.value.trim()
    if (value.length === 0) return

    if (value.includes('@')) {
      window.location.href = `${this.pathValue}?search=${encodeURIComponent(value)}`
    }
    else {
      window.location.href = `${this.pathValue}/${encodeURIComponent(value)}`
    }
  }

  cancelOrder = () => {
    if (!window.confirm('Confirm cancel and refund order')) return

    post(this.cancelOrderPathValue, { responseKind: 'json' }).then(function () {
      window.location.reload()
    })
  }
}
